import { JobWorkspaceIcon } from "./icons";
import { DetailField, WorkspaceCard } from "./ui";

/**
 * Dispatch note, schedule, and related people for one job.
 * @param {{ view: object, onEditNote?: () => void }} props
 * @returns {JSX.Element}
 */
export function DispatchDetails({ view, onEditNote }) {
  return (
    <div className="flex flex-col gap-6">
      <WorkspaceCard className="flex flex-col gap-5 p-5">
        <div className="flex items-center justify-between gap-3">
          <h2 className="text-[15px] font-semibold leading-normal text-[#202b33]">
            Dispatch details
          </h2>
          <p className="text-[10px] font-normal leading-normal text-[#6e7b84]">
            All times in UTC
          </p>
        </div>
        <div className="flex items-start gap-3 rounded-[6px] bg-[#f7f9fa] p-[14px]">
          <JobWorkspaceIcon name="clipboardList" />
          <div className="flex min-w-0 flex-1 flex-col gap-[7px]">
            <p className="text-[10px] font-semibold leading-normal text-[#6e7b84]">
              DISPATCH NOTE
            </p>
            {onEditNote ? (
              <button
                type="button"
                onClick={onEditNote}
                aria-label={`Edit dispatch note: ${view.dispatchNote}`}
                className="text-left text-[13px] font-medium leading-[1.6] text-[#202b33] hover:underline"
              >
                {view.dispatchNote}
              </button>
            ) : (
              <p className="text-[13px] font-medium leading-[1.6] text-[#202b33]">
                {view.dispatchNote}
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-wrap gap-6">
          {view.schedule.map((item) => (
            <DetailField key={item.label} label={item.label} value={item.value} />
          ))}
        </div>
      </WorkspaceCard>
      <WorkspaceCard className="flex flex-col gap-5 p-5">
        <h2 className="text-[15px] font-semibold leading-normal text-[#202b33]">
          People & references
        </h2>
        <div className="flex flex-wrap gap-6">
          {view.people.map((person) => (
            <DetailField
              key={person.label}
              label={person.label}
              value={person.title}
              detail={person.detail}
              to={person.to}
            />
          ))}
        </div>
        <div className="h-px w-full bg-[#e2e7ea]" />
        <div className="flex items-center justify-between gap-3">
          <p className="inline-flex items-center gap-[7px] text-[11px] font-normal leading-normal text-[#6e7b84]">
            <JobWorkspaceIcon name="shieldCheck" />
            {view.complianceLabel}
          </p>
          <p className="text-[11px] font-normal leading-normal text-[#6e7b84]">
            {view.aiCreatedLabel}
          </p>
        </div>
      </WorkspaceCard>
    </div>
  );
}
